import { useQuery } from '@apollo/client';

import { UserProfileQueryDocument } from './getUserProfile.gql';

export const useGetUserProfile = () => {
  const { data, ...hook } = useQuery(UserProfileQueryDocument);

  const user = data?.viewer.profile;

  return { ...hook, user };
};

export type UserProfile = NonNullable<
  ReturnType<typeof useGetUserProfile>['user']
>;
